// extracted by mini-css-extract-plugin
module.exports = {"stepsContent":"stepsContent[Frida]58U_hAnd","stepsAction":"stepsAction[Frida]1qEs0Gxa"};